import Card from "react-bootstrap/Card";
import TaskModel from "@/models/Task";
import moment from "moment";
import { colorYiq } from "@/utils/colorYiq";
import { Link } from "react-router-dom";
import { BsPencil } from "react-icons/bs";
import { PriorityBadge } from "@/components/PriorityBadge";

export type TaskProps = Pick<
  TaskModel,
  "title" | "description" | "id" | "priority"
> & {
  category?: {
    name: string;
    id: string;
  };
  tags?: {
    name: string;
    id: string;
    color: string;
  }[];
  dueDate?: moment.Moment | null;
};

export const TaskComponent: React.FC<TaskProps> = ({
  id,
  title,
  description,
  category,
  tags,
  dueDate,
  priority,
}) => (
  <Link
    to={`/tasks/edit/${id}`}
    style={{ textDecoration: "none" }}
    className="task-card-link"
  >
    <Card text="light" bg="dark" style={{ cursor: "pointer" }}>
      <Card.Body>
        <Card.Title className="d-flex justify-content-start align-items-center">
          <div>
            {category && (
              <span className="small">
                <span className="link-light" style={{ pointerEvents: "none" }}>
                  {category.name}
                </span>
                {` > `}
              </span>
            )}
            {title}
            <PriorityBadge priority={priority} />
          </div>
          <div className="d-flex flex-grow-1 justify-content-end">
            {dueDate &&
              (() => {
                const now = moment();
                const isOverdue = dueDate.isBefore(now, "day");
                const isToday = dueDate.isSame(now, "day");
                let dueClass = "";
                if (isOverdue) dueClass = "text-danger";
                else if (isToday) dueClass = "text-warning";
                return (
                  <strong
                    className={`small ${dueClass}`}
                    title={dueDate.format("YYYY-MM-DD HH:mm")}
                  >
                    {moment(dueDate).from(now)}
                  </strong>
                );
              })()}
            <span
              title="Edit Task"
              className="link-light ms-3"
              style={{
                pointerEvents: "none",
                display: "flex",
                alignItems: "center",
              }}
            >
              <BsPencil />
            </span>
          </div>
        </Card.Title>
        <Card.Text>
          <p>{description}</p>
          {tags && tags.length > 0 ? (
            <p>
              {tags.map((tag) => (
                <span
                  style={{
                    backgroundColor: tag.color,
                    color: colorYiq(tag.color),
                  }}
                  key={tag.id}
                  className="me-1 badge rounded-pill"
                >
                  {tag.name}
                </span>
              ))}
            </p>
          ) : null}
        </Card.Text>
      </Card.Body>
    </Card>
  </Link>
);
